// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import VueWorker from 'vue-worker'
import Login from './components/Login.vue'
import Sales from './components/Sales.vue'
import Sidebar from './components/Sidebar.vue'
import Order from './components/Order.vue'
import '@fortawesome/fontawesome-free/css/all.min.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'mdbvue/build/css/mdb.css'
import VueLocalStorage from 'vue-localstorage'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Vue2TouchEvents from 'vue2-touch-events'
import moment from 'vue-moment'
import VuejsDialog from 'vuejs-dialog'
import 'vuejs-dialog/dist/vuejs-dialog.min.css'
import BackToTop from 'vue-backtotop'
import VueTimers from 'vue-timers'
import VueFuse from 'vue-fuse'
import YmapPlugin from 'vue-yandex-maps'
import Chat from 'vue-beautiful-chat'
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'

var VueScrollTo = require('vue-scrollto')
Vue.component('login', Login)
Vue.component('sidebar', Sidebar)
Vue.component('sales', Sales)
Vue.use(VueWorker)
Vue.component('order', Order)
Vue.use(YmapPlugin)
Vue.use(VueFuse)
Vue.use(BackToTop)
Vue.use(VueTimers)
Vue.use(VueScrollTo)
Vue.use(VuejsDialog, {
  html: true,
  loader: false,
  okText: 'Ok',
  cancelText: 'Отмена',
  animation: 'fade'
})
// see docs for available options
const datepickerOptions = {
  sundayFirst: false,
  dateLabelFormat: 'dddd, MMMM D, YYYY',
  days: ['Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота', 'Воскресенье'],
  daysShort: ['Пнд', 'Втр', 'Срд', 'Чтв', 'Птн', 'Суб', 'Вск'],
  monthNames: [
    'Январь',
    'Февраль',
    'Март',
    'Апрель',
    'Май',
    'Июнь',
    'Июль',
    'Август',
    'Сентябрь',
    'Октябрь',
    'Ноябрь',
    'Декабрь'
  ],
  colors: {
    selected: '#00a699',
    inRange: '#66e2da',
    selectedText: '#fff',
    text: '#565a5c',
    inRangeBorder: '#33dacd',
    disabled: '#fff'
  },
  texts: {
    apply: 'Выбрать',
    cancel: 'Отмена',
    keyboardShortcuts: 'Keyboard Shortcuts'
  },
  keyboardShortcuts: [
    {symbol: '↵', label: 'Выбрать дату в фокусе', symbolDescription: 'Enter key'},
    {symbol: '←/→', label: 'Назад (влево) или вперед (вправо) на один день.', symbolDescription: 'Left or right arrow keys'},
    {symbol: '↑/↓', label: 'Назад (вверх) или вперед (вниз) на одну неделю.', symbolDescription: 'Up or down arrow keys'},
    {symbol: 'PgUp/PgDn', label: 'Переключать месяцы.', symbolDescription: 'PageUp and PageDown keys'},
    {symbol: 'Home/End', label: 'Первый или последний день недели.', symbolDescription: 'Home or End keys'},
    {symbol: 'Esc', label: 'Закрыть справку', symbolDescription: 'Escape key'},
    {symbol: '?', label: 'Открыть справку', symbolDescription: 'Question mark'}
  ]
}
// make sure we can use it in our components
Vue.use(AirbnbStyleDatepicker, datepickerOptions)
Vue.use(moment)
Vue.use(Vue2TouchEvents)
Vue.use(VueAxios, axios)
Vue.use(VueLocalStorage)
Vue.use(Chat)
Vue.config.productionTip = false
/* eslint-disable no-new */
function debounce (fn, delay = 300) {
  var timeoutID = null
  return function () {
    clearTimeout(timeoutID)
    var args = arguments
    var that = this
    timeoutID = setTimeout(function () {
      fn.apply(that, args)
    }, delay)
  }
}

// this is where we integrate the v-debounce directive!
// We can add it globally (like now) or locally!
Vue.directive('debounce', (el, binding) => {
  if (binding.value !== binding.oldValue) {
    // window.debounce is our global function what we defined at the very top!
    el.oninput = debounce(ev => {
      el.dispatchEvent(new Event('change'))
    }, parseInt(binding.value) || 300)
  }
})

Object.defineProperty(Vue.prototype, '$bus', {
  get: function () {
    return this.$root.bus
  }
})

new Vue({
  el: '#app',
  router,
  components: { App },
  data: {
    bus: new Vue({}) // Here we bind our event bus to our $root Vue model.
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js